/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React, {Component} from 'react';
import {Button, Card, Col, DatePicker, Form, Icon, Input, Row, Select, Spin, Table} from 'antd';
import {sanitizeFieldName} from "../../util/methods";
import moment from "moment/moment";

class PVCombineReport extends Component {

  state = {
    availableForDownload: false,
    searchText: '',
    searchedColumn: '',
  };

  componentDidMount() {
    this.props.fetchLocSubLoc();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.combineReportData && nextProps.combineReportData.length) {
      this.setState({
        availableForDownload: true
      })
    } else {
      this.setState({
        availableForDownload: false
      })
    }
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({searchText: ''});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      this.props.fetchReportData(values);
    });
  };

  handleDownload = () => {
    this.props.downloadCombineData(this.props.combineReportData);
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {loading, title, resource, locationData, subLocationData, combineReportData} = this.props;
    const cols = [
      {
        title: 'PV No',
        dataIndex: 'pvNo',
        key: 'pvNo',
        width: 100,
        sorter: (a, b) => (a.pvNo.length) || 0 - (b.pvNo.length) || 0,
        ...this.getColumnSearchProps('pvNo'),
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        width: 100,
        sorter: (a, b) => (a.location && a.location.name && a.location.name.length) || 0 - (b.location && b.location.name && b.location.name.length) || 0,
        render: (location) => location && location.name,
        // ...this.getColumnSearchProps('location'),
      },
      {
        title: 'Sub Location',
        dataIndex: 'subLocation',
        key: 'subLocation',
        width: 100,
        sorter: (a, b) => (a.subLocation && a.subLocation.name && a.subLocation.name.length) || 0 - (b.subLocation && b.subLocation.name && b.subLocation.name.length) || 0,
        render: (subLocation) => subLocation && subLocation.name
      },
      {title: 'Status', dataIndex: 'status', key: 'status', width: 100, sorter: true,},
      {
        title: 'Opened By',
        dataIndex: 'openedBy',
        key: 'openedBy',
        width: 120,
        render: (openedBy) => openedBy && openedBy.name
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 100,
        sorter: (a, b) => new Date(a.assetDetails.time).getTime() - new Date(b.assetDetails.time).getTime(),
        render: (_, record) => record.assetDetails && record.assetDetails.time && moment(record.assetDetails.time).format('DD-MM-YYYY')
      },
      {
        title: 'User',
        dataIndex: 'user',
        key: 'user',
        width: 120,
        render: (_, record) => record.assetDetails && record.assetDetails.user && record.assetDetails.user.name
      },
      {
        title: 'Existing Code',
        dataIndex: 'existingAssetCode',
        key: 'existingAssetCode',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.existingAssetCode
      },
      {
        title: 'Temp Id',
        dataIndex: 'tempAssetCode',
        key: 'tempAssetCode',
        width: 100,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.tempAssetCode && a.assetDetails.tempAssetCode.name && a.assetDetails.tempAssetCode.name.length) || 0 - (b.assetDetails && b.assetDetails.tempAssetCode && b.assetDetails.tempAssetCode.name && b.assetDetails.tempAssetCode.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.tempAssetCode
      },
      {
        title: 'QR Id',
        dataIndex: 'tempQrCode',
        key: 'tempQrCode',
        width: 100,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.tempQrCode && a.assetDetails.tempQrCode.name && a.assetDetails.tempQrCode.name.length) || 0 - (b.assetDetails && b.assetDetails.tempQrCode && b.assetDetails.tempQrCode.name && b.assetDetails.tempQrCode.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.tempQrCode && record.assetDetails.tempQrCode.replace('qr#', '')
      },
      {
        title: 'Parent Code',
        dataIndex: 'parentAssetCode',
        key: 'parentAssetCode',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.parentAssetCode
      },
      {
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
        width: 100,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.assetType && a.assetDetails.assetType.name && a.assetDetails.assetType.name.length) || 0 - (b.assetDetails && b.assetDetails.assetType && b.assetDetails.assetType.name && b.assetDetails.assetType.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.assetType && record.assetDetails.assetType.name
      },
      {
        title: 'Sub Type',
        dataIndex: 'equipmentSubType',
        key: 'equipmentSubType',
        width: 100,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.equipmentSubType && a.assetDetails.equipmentSubType.name && a.assetDetails.equipmentSubType.name.length) || 0 - (b.assetDetails && b.assetDetails.equipmentSubType && b.assetDetails.equipmentSubType.name && b.assetDetails.equipmentSubType.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.equipmentSubType && record.assetDetails.equipmentSubType.name
      },
      {
        title: 'Asset Model',
        dataIndex: 'assetModel',
        key: 'assetModel',
        width: 100,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.assetModel && a.assetDetails.assetModel.name && a.assetDetails.assetModel.name.length) || 0 - (b.assetDetails && b.assetDetails.assetModel && b.assetDetails.assetModel.name && b.assetDetails.assetModel.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.assetModel && record.assetDetails.assetModel.name
      },
      {
        title: 'Custodian',
        dataIndex: 'assetCustodian',
        key: 'assetCustodian',
        width: 120,
        render: (_, record) => record.assetDetails && record.assetDetails.assetCustodian && record.assetDetails.assetCustodian.name
      },
      {
        title: 'Condition',
        dataIndex: 'condition',
        key: 'condition',
        width: 120,
        sorter: (a, b) => (a.assetDetails && a.assetDetails.physicalCondition && a.assetDetails.physicalCondition.name && a.assetDetails.physicalCondition.name.length) || 0 - (b.assetDetails && b.assetDetails.physicalCondition && b.assetDetails.physicalCondition.name && b.assetDetails.physicalCondition.name.length) || 0,
        render: (_, record) => record.assetDetails && record.assetDetails.physicalCondition && record.assetDetails.physicalCondition.name
      },
      {
        title: 'Latitude',
        dataIndex: 'lat',
        key: 'lat',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.latitude
      },
      {
        title: 'Longitude',
        dataIndex: 'lng',
        key: 'lng',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.longitude
      },
      {
        title: 'Utilisation Level',
        dataIndex: 'utilisationLevel',
        key: 'utilisationLevel',
        width: 150,
        render: (_, record) => record.assetDetails && record.assetDetails.utilisationLevel
      },
      {
        title: 'is Countable',
        dataIndex: 'countable',
        key: 'countable',
        width: 150,
        render: (_, record) => (record.assetDetails && record.assetDetails.countable) ? 'Yes' : 'No'
      },
      {
        title: 'Serial Number',
        dataIndex: 'serialNumber',
        key: 'serialNumber',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.serialNumber
      },
      {
        title: 'Qty',
        dataIndex: 'qty',
        key: 'qty',
        width: 50,
        render: (_, record) => record.assetDetails && record.assetDetails.qty
      },
      {
        title: 'Time',
        dataIndex: 'time',
        key: 'time',
        width: 120,
        render: (_, record) => record.assetDetails && record.assetDetails.time && moment(record.assetDetails.time).format('hh:mm:ss')
      },
      {
        title: 'Readings',
        dataIndex: 'reading',
        key: 'reading',
        width: 200,
        render: (_, record) => {
          let reading = '--';
          if (record.assetDetails && record.assetDetails.reading && record.assetDetails.reading.length) {
            reading = record.assetDetails.reading.map((read, index) => (
              <span key={`R${index}`}>{`${read && read.meter}, `}</span>))
          }
          return (<span>{reading}</span>);
        }
      },
      {
        title: 'Attachments',
        dataIndex: 'attachments',
        key: 'attachments',
        width: 200,
        render: (_, record) => {
          let photos = '--';
          if (record.assetDetails && record.assetDetails.photos && record.assetDetails.photos.length) {
            photos = record.assetDetails.photos.map((photo, index) => (
              <span key={`P${index}`}>
                <a target='_blank' key={photo.url} href={photo.url}> {`Attachment-${(index + 1)}`}</a>
                <br/>
              </span>))
          }
          return (<span>{photos}</span>);
        }
      },
    ];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${sanitizeFieldName(resource)} ${title}`}>
          <Form onSubmit={this.handleSubmit} className="ant-advanced-search-form" layout="inline" labelAlign="left">

            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'location'} label={'Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`location`, {
                    rules: [{required: true, message: `Location is required!`}],
                  })(<Select
                    showSearch
                    showArrow
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Select Location`}
                  >
                    <Select.Option key={'loc-all'} value={'all'}>All</Select.Option>
                    {(locationData.data || []).map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                    }
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'subLocation'} label={'Sub Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`subLocation`, {
                    rules: [{required: true, message: `Sub Location is required!`}],
                  })(<Select
                    showSearch
                    showArrow
                    // onChange={value => this.handleSelect('subLocation', value)}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Select Sub Location`}
                  >
                    <Select.Option key={'sloc-all'} value={'all'}>All</Select.Option>
                    {(subLocationData.data || []).map(item =>
                      <Select.Option key={item._id}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'periodFrom'} label={'Select Period From'} style={{width: '100%'}}>
                  {getFieldDecorator(`periodFrom`, {
                    rules: [{required: true, message: `Period From is required!`}],
                    initialValue: null,
                  })(<DatePicker style={{width: '100%'}}/>)}
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'periodTo'} label={'Select Period To'} style={{width: '100%'}}>
                  {getFieldDecorator(`periodTo`, {
                    rules: [{required: true, message: `Period To is required!`}],
                    initialValue: null,
                  })(<DatePicker style={{width: '100%'}}/>)}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Generate Report
              </Button>
              {this.state.availableForDownload && (
                <Button icon={'download'} type="secondary" htmlType="button" loading={loading}
                        onClick={this.handleDownload}>
                  Download
                </Button>)}
            </Form.Item>
          </Form>

        </Card>
        <Card>
          {combineReportData && combineReportData.length ?
            <Table
              pagination={{pageSize: 10}} bordered
              loading={loading}
              columns={cols}
              dataSource={combineReportData}
              scroll={{x: true}} size="small"
              rowKey={record => record._id + record.assetDetails.tempAssetCode + record.assetDetails.time}
            /> : null
          }
        </Card>
      </Spin>
    );
  }
}

export default Form
  .create({name: 'pv-combine'})

  (
    PVCombineReport
  )
;
